'use client';

import { c as _c } from "react/compiler-runtime";
import { Heading, HorizontalOverflowCarousel, HorizontalOverflowCarouselItem, LayoutContainer, TextLink, TextPassage } from '@petsmart-ui/sparky';
import cn from 'classnames';
import { usePathname } from 'next/navigation';
import { trackContentfulClick } from '@libs/analytics';
import { NavCard } from './NavCard';
import { PromoCard } from './PromoCard';
import type { PromoCarouselProps } from './types';
import './PromoCarousel.scss';
export function PromoCarousel(t0) {
  const $ = _c(36);
  const {
    header,
    link,
    description,
    leftBlock,
    rightBlock,
    leftBlockTextColor
  } = t0;
  const pathname = usePathname();
  let t1;
  if ($[0] !== header) {
    t1 = <Heading tagName="h2">{header}</Heading>;
    $[0] = header;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== description) {
    t2 = <TextPassage align="center">{description}</TextPassage>;
    $[2] = description;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== link?.actionText || $[5] !== link?.link) {
    t3 = link?.link && <TextLink href={link?.link?.webUrl}>{link?.actionText}</TextLink>;
    $[4] = link?.actionText;
    $[5] = link?.link;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== header || $[8] !== leftBlock || $[9] !== leftBlockTextColor || $[10] !== pathname) {
    let t5;
    if ($[12] !== header || $[13] !== leftBlockTextColor || $[14] !== pathname) {
      t5 = (nav, index) => <NavCard key={nav.sysId} {...nav} textColor={leftBlockTextColor} handleAnalytics={() => trackContentfulClick({
        position: index + 1,
        linkText: nav.header,
        linkUrl: nav.link?.webUrl ?? "",
        promoTitle: header,
        promoVariant: "storytelling card up - promo carousel - Nav Card",
        promoOrigin: pathname,
        promoDesc: nav.internalTitle,
        promoType: "nav-card"
      })} />;
      $[12] = header;
      $[13] = leftBlockTextColor;
      $[14] = pathname;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    t4 = leftBlock.map(t5);
    $[7] = header;
    $[8] = leftBlock;
    $[9] = leftBlockTextColor;
    $[10] = pathname;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[16] !== t4) {
    t5 = <div className="c-promo-carousel__navs">{t4}</div>;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      "560": {
        gap: 8,
        perView: 1.3
      },
      "768": {
        gap: 24,
        perView: 2.2
      },
      "960": {
        gap: 24,
        perView: 2.5
      }
    };
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== header || $[20] !== pathname || $[21] !== rightBlock) {
    let t8;
    if ($[23] !== header || $[24] !== pathname) {
      t8 = (promo, index_0) => <HorizontalOverflowCarouselItem key={promo.sysId}><PromoCard {...promo} handleAnalytics={() => trackContentfulClick({
          position: index_0 + 1,
          linkText: cn(promo.header, promo.bodyText, promo.cta?.text),
          linkUrl: promo.cta?.link.webUrl ?? "",
          promoTitle: header,
          promoVariant: "storytelling card up - promo carousel - Promo Card",
          promoOrigin: pathname,
          promoDesc: promo.internalTitle,
          promoType: "c-promo-card"
        })} /></HorizontalOverflowCarouselItem>;
      $[23] = header;
      $[24] = pathname;
      $[25] = t8;
    } else {
      t8 = $[25];
    }
    t7 = rightBlock.map(t8);
    $[19] = header;
    $[20] = pathname;
    $[21] = rightBlock;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[26] !== t7) {
    t8 = <div className="c-promo-carousel__carousel"><HorizontalOverflowCarousel perViewDefault={2} breakpoints={t6}>{t7}</HorizontalOverflowCarousel></div>;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== t5 || $[29] !== t8) {
    t9 = <div className="c-promo-carousel__content">{t5}{t8}</div>;
    $[28] = t5;
    $[29] = t8;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== t1 || $[32] !== t2 || $[33] !== t3 || $[34] !== t9) {
    t10 = <LayoutContainer className="c-promo-carousel">{t1}{t2}{t3}{t9}</LayoutContainer>;
    $[31] = t1;
    $[32] = t2;
    $[33] = t3;
    $[34] = t9;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  return t10;
}